
import xcomponent from 'xcomponent/dist/xcomponent';
import { getComponentCurrentScript } from '../utils/getComponentCurrentScript';

const componentCurrentScript = getComponentCurrentScript(['connectorComponent.bundle.js', 'connector.bundle.js']);

(<any>window).NtxConnector = xcomponent.create({
    // The html tag used to render my component
    tag: 'nintex-connector',

    // The url that will be loaded in the iframe or popup, when someone includes my component on their page
    url: componentCurrentScript.src.replace(/[^\/]+$/, 'connector.html'),

    // A bridge to allow IE to send messeges to child window via an Iframe
    bridgeUrl: componentCurrentScript.src.replace(/[^\/]+$/, 'cross-window-bridge.html'),

    // The size of the component on their page
    dimensions: {
        width: '800px',
        height: '600px'
    },

    contexts: {
        popup: true
    },

    defaultLogLevel: 'warn',

    // The properties they can (or must) pass down to my component
    props: {
        getAccessTokenAsync: {
            type: 'function',
            required: true
        },
        selectedAppId: {
            type: 'string',
            required: false
        },
        selectedConnectionId: {
            type: 'string',
            required: false
        },
        onSuccess: {
            type: 'function',
            required: true
        },
        onFailure: {
            type: 'function',
            required: true
        },
        theme: {
            type: 'object',
            required: false
        },
        langs: {
          type: 'string',
          required: false
        },
        isAiXtensionsBuilderEnabled: {
            type: 'boolean',
            required: false
        },
    }
});



// WEBPACK FOOTER //
// ./src/xcomponents/connector/definition.ts